import { render, staticRenderFns } from "./Concerts.vue?vue&type=template&id=6cc785d4&"
import script from "./Concerts.vue?vue&type=script&lang=js&"
export * from "./Concerts.vue?vue&type=script&lang=js&"
import style0 from "./Concerts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports